const addFacetNameToOption = facetName => (
    option => Object.assign(option, {facetName})
);

const ignoreFacets = facetsToIgnore => (
    facetName => !facetsToIgnore.includes(facetName)
);

const ignoreOrderedFacets = facetsToIgnore => (
  ({facetName}) => !facetsToIgnore.includes(facetName)
);

const extractOptionsFrom = appliedFacets => (
    facetName => appliedFacets[facetName].map(
        addFacetNameToOption(facetName))
);

const combineAllOptions = (combinedOptions, options) => (
    combinedOptions.concat(options)
);

const getId = option => option.id || option.searchFacetOptionId;

const getName = option => option.name || option.searchFacetOptionValue;

const getDisplayName = option => option.tagDisplayLabel ?? getName(option);

const adaptAppliedOption = option => ({
  id: getId(option),
  name: getName(option),
  facetName: option.facetName,
  displayName: getDisplayName(option),
});

const adaptAppliedOptions = (appliedFacets, ignoredFacets) => (
    Object.keys(appliedFacets).
        filter(ignoreFacets(ignoredFacets)).
        map(extractOptionsFrom(appliedFacets)).
        reduce(combineAllOptions, []).
        map(adaptAppliedOption)
);

export const adaptOrderedOptions = (appliedFacets, ignoredFacets) => (
  appliedFacets?.filter(ignoreOrderedFacets(ignoredFacets)).map(adaptAppliedOption).reverse() || []
);

export default adaptAppliedOptions;
